@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: inherit;
}

.modal {
    position: fixed;
    inset: 0;
    z-index: 100;
}

.dialog {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    align-items: center;
    height: 100%;
    outline: 0;
}

.overlay {
    position: absolute;
    inset: 0;
    background-color: rgb(var(--black-base) / 45%);
    z-index: 0;
}

.close {
    position: absolute;
    top: var(--spacer-16);
    right: var(--spacer-16);
    width: var(--spacer-24);
    height: var(--spacer-24);
}

.content {
    position: relative;
    grid-column: 4 / span 6;
    max-height: 94vh;
    padding: var(--spacer-64) var(--spacer-80);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: var(--white);
    text-align: center;
    z-index: 1;

    @media ($below-tablet) {
        grid-column: 3 / span 8;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
        padding: var(--spacer-32);
    }
}

.title {
    font: var(--font-h-34);
    margin-bottom: var(--spacer-8);
}

.subtitle {
    font: var(--font-p-16);
    color: var(--medium-gray);
}

.selectContainer {
    margin-top: var(--spacer-56);
    display: flex;
    gap: var(--spacer-16);
    align-items: center;
    height: 50px;

    @media ($below-mobile) {
        flex-direction: column;
        align-items: stretch;
        gap: var(--spacer-24);
        height: auto;
    }
}

.select {
    flex: 1;
    height: 100%;

    > span {
        margin: 0;
    }

    button {
        height: 100%;
    }
}

.downCaret {
    width: var(--spacer-16);
    height: var(--spacer-16);
    color: var(--gray-500);
    transform: rotate(90deg);
}

.popover {
    background-color: var(--white);
    border: 1px solid var(--gray-300);
    border-radius: var(--border-radius-small);
    box-shadow: var(--shadow-medium);
    z-index: 10;
}

.listBox {
    max-height: 200px;
    overflow-y: auto;
    padding: var(--spacer-4) 0;
}

.listBoxItem {
    padding: var(--spacer-12) var(--spacer-16);
    cursor: pointer;
    font-size: var(--font-size-body);
    color: var(--black);

    &:hover {
        background-color: var(--gray-50);
    }

    &[data-selected] {
        background-color: var(--primary-100);
        color: var(--primary-700);
    }

    &:focus-visible {
        outline: 2px solid var(--focus-color);
        outline-offset: -2px;
    }
}

.continueButton {
    flex-shrink: 0;

    @media ($below-mobile) {
        width: 100%;
    }
}
